import { FormattedMessage, useIntl } from "react-intl";
import DefaultTemplate from "../layout/content-templates/default/DefaultTemplate.tsx";
import styles from "./Expired.module.scss";
import usePaginatedAssetFetcherStatus from "../common/asset-load/usePaginatedAssetFetcherStatus.ts";
import PaginatedAssetFetcherStatus from "../common/asset-load/PaginatedAssetFetcherStatus.tsx";
import { LoadableExpiredAssetChunk } from "./LoadableExpiredAssetChunk.tsx";
import ExpiredOnboardingBanner from "./ExpiredOnboardingBanner.tsx";
import { Fetcher } from "react-router-dom";
import useStateArray from "../../../common/core-ui/useStateArray.ts";
import PageTitle from "../common/page-title/PageTitle.tsx";

export default function Expired() {
  const intl = useIntl();
  const [fetchers, updateFetcher] = useStateArray<Fetcher>();
  const { contentLengthStatus } = usePaginatedAssetFetcherStatus(fetchers);
  const title = intl.formatMessage({ defaultMessage: "Expired" });

  return (
    <DefaultTemplate title={title}>
      {contentLengthStatus === "has-content" && <ExpiredOnboardingBanner />}
      <PageTitle title={title} />
      <ul className={styles.assetList}>
        <LoadableExpiredAssetChunk
          onSetFetcher={(fetcher) => {
            updateFetcher(fetcher, 0);
          }}
        />
      </ul>
      <PaginatedAssetFetcherStatus
        fetchers={fetchers}
        // This page is not presented to the user when they don't have expired items,
        // but show a message just in case they came here by direct link
        emptyState={<FormattedMessage defaultMessage="No expired items" />}
      />
    </DefaultTemplate>
  );
}
